import { variantSpecRange } from './variantSpecRange.js'

export function selectableVariantsCount(product) {
  if (Number.isInteger(product?.selectable_variants_count)) {
    return product.selectable_variants_count
  }

  return product?.selectable_variants?.length || 0
}

export function selectableVariantsRange(product, key) {
  const ranges = product?.selectable_variants_ranges

  if (ranges && Object.prototype.hasOwnProperty.call(ranges, key)) {
    return ranges[key]
  }

  return variantSpecRange(product?.selectable_variants, key)
}
